import jsPDF from 'jspdf';
import React, { FC } from 'react';
import { font } from '../../assets/fonts/roboto/Roboto-Light-normal';
import { boldFont } from '../../assets/fonts/roboto/Roboto-Bold-normal';

export const PetitionPDF: FC<{
    data?: any;
    amount: any;
}> = ({ data, amount }) => {
    const pdf = new jsPDF({ filters: ['ASCIIHexEncode'] });
    pdf.setFontSize(12);
    pdf.addFileToVFS('../../assets/fonts/roboto/Roboto-Light.ttf', font);
    pdf.addFileToVFS('../../assets/fonts/roboto/Roboto-Bold.ttf', boldFont);
    pdf.addFont('../../assets/fonts/roboto/Roboto-Light.ttf', 'Roboto', 'normal');
    pdf.addFont('../../assets/fonts/roboto/Roboto-Bold.ttf', 'RobotoBold', 'normal');
    pdf.setFont('RobotoBold');
    pdf.text(' ', 10, 10);
    pdf.text('LCWAIKIKI MAĞAZACILIK HİZMETLERİ TİC. A.Ş.', 10, 20);
    pdf.setFont('Roboto');
    pdf.text('15 Temmuz Mah. Gülbahar Cad. No:96 34544 Bağcılar/İstanbul', 10, 30);
    pdf.setFontSize(12);
    pdf.text('T 0 212 657 55 55 - 657 30 30', 10, 40);
    pdf.setFontSize(12);
    pdf.text('F 0 212 657 00 60 - 657 64 56', 10, 50);
    pdf.setFontSize(12);
    pdf.text('www.LCWaikiki.com', 10, 60);
    pdf.setFontSize(12);
    pdf.setFont('RobotoBold');
    pdf.text('AKBANK İSTANBUL KURUMSAL ŞUBE MÜDÜRLÜĞÜNE', 10, 70);
    pdf.setFontSize(12);
    pdf.text(new Date().toLocaleDateString(), 10, 80);
    pdf.setFontSize(12);
    pdf.text('İstanbul', 10, 90);
    pdf.setFont('Roboto');
    pdf.setFontSize(12);
    pdf.text(
        'Nezdinizde bulunan TR920004600763888000071011 IBAN numaralı hesabımızdan aşağıda bilgileri bulunan ',
        10,
        100
    );
    pdf.setFontSize(12);
    pdf.text('Havale/EFT’lerin Toplu Ödeme Sistemi (TÖS) ile yapılmasını rica ederiz. ', 10, 110);
    pdf.setFont('RobotoBold');
    pdf.text('AÇIKLAMA : İNTERNET SATIŞ İADE İŞLEMİ', 10, 120);
    pdf.setFontSize(12);
    pdf.text('NOT: MASRAF TAHSİL EDİLMEYECEKTİR.', 10, 130);
    pdf.setFont('Roboto');
    pdf.setFontSize(12);
    pdf.text('Saygılarımızla', 10, 150);
    pdf.setFontSize(8);

    pdf.text('No', 10, 170);
    pdf.text('Alıcı', 40, 170); // Kolon genişliğini artır
    pdf.text('Banka', 90, 170); // Kolon genişliğini artır
    pdf.text('IBAN', 140, 170); // Kolon genişliğini artır
    pdf.text('Tutar', 190, 170); // Kolon genişliğini artır

    const MAX_Y = 280; // Sayfanın maksimum yüksekliği

    let yPos = 180;

    data.forEach((rowData: any) => {
        if (yPos > MAX_Y) {
            pdf.addPage(); // Yeni sayfa ekle
            yPos = 10; // Y pozisyonunu sıfırla
        }
        if (rowData.No) {
            pdf.text(rowData.No.toString(), 10, yPos);
        }
        if (rowData.Alıcı) {
            pdf.text(rowData.Alıcı, 40, yPos); // Kolon genişliğini artır
        }
        if (rowData.Banka) {
            pdf.text(rowData.Banka, 90, yPos); // Kolon genişliğini artır
        }
        if (rowData.IBAN) {
            pdf.text(rowData.IBAN, 140, yPos); // Kolon genişliğini artır
        }
        if (rowData.Tutar) {
            pdf.text(rowData.Tutar, 190, yPos); // Kolon genişliğini artır
        }
        yPos += 10;
    });

    // Toplam Tutar
    if (yPos > MAX_Y) {
        pdf.addPage(); // Yeni sayfa ekle
        yPos = 10; // Y pozisyonunu sıfırla
    }

    pdf.text('Toplam Tutar', 10, yPos);

    pdf.text('Toplam Tutar', 10, yPos);
    pdf.text(amount, 190, yPos);
    pdf.save('PetitionRefundList' + new Date().toJSON().slice(0, 10).replace(/-/g, '_') + '.pdf');
    pdf.output('dataurlnewwindow'); //opens the data uri in new window
    return <React.Fragment />;
};
